import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, AwardIcon } from 'lucide-react';
import { Certificate } from '../hooks/useProgress';
interface CertificateCardProps {
  certificate: Certificate;
  onClick: () => void;
}
export function CertificateCard({
  certificate,
  onClick
}: CertificateCardProps) {
  return <motion.div whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`
        relative w-full h-48 rounded-xl p-1 cursor-pointer shadow-lg transition-all duration-300 overflow-hidden group
        ${certificate.isEarned ? `bg-gradient-to-br ${certificate.gradient}` : 'bg-gray-200'}
      `} data-id="element-538">
      <div className="absolute inset-0 bg-white m-[2px] rounded-[10px] p-5 flex flex-col justify-between relative overflow-hidden" data-id="element-539">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-[0.03] bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-540"></div>

        {/* Header */}
        <div className="flex justify-between items-start relative z-10" data-id="element-541">
          <div className={`
            w-12 h-12 rounded-full flex items-center justify-center
            ${certificate.isEarned ? `bg-gradient-to-br ${certificate.gradient} text-white` : 'bg-gray-100 text-gray-400'}
          `} data-id="element-542">
            <AwardIcon className="w-6 h-6" data-id="element-543" />
          </div>

          {!certificate.isEarned && <LockIcon className="w-5 h-5 text-gray-400" data-id="element-544" />}

          {certificate.isEarned && <div className={`px-3 py-1 rounded-full text-xs font-bold text-white bg-gradient-to-r ${certificate.gradient}`} data-id="element-545">
              Finalizat
            </div>}
        </div>

        {/* Content */}
        <div className="relative z-10" data-id="element-546">
          <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1" data-id="element-547">
            Certificat de Absolvire
          </p>
          <h3 className={`font-bold text-lg leading-tight mb-2 ${certificate.isEarned ? 'text-gray-900' : 'text-gray-400'}`} data-id="element-548">
            {certificate.courseName}
          </h3>

          {certificate.isEarned ? <p className="text-xs text-gray-500" data-id="element-549">
              Obținut la:{' '}
              {new Date(certificate.earnedAt!).toLocaleDateString('ro-RO')}
            </p> : <p className="text-xs text-gray-400" data-id="element-550">
              Completează toate modulele pentru a debloca
            </p>}
        </div>

        {/* Decorative Corner */}
        {certificate.isEarned && <div className={`absolute -bottom-6 -right-6 w-24 h-24 rounded-full bg-gradient-to-br ${certificate.gradient} opacity-10 group-hover:opacity-20 transition-opacity`} data-id="element-551"></div>}
      </div>
    </motion.div>;
}